import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  submitButton: {
    padding: theme.spacing(1.5, 1),
    fontSize: '12px',
    textTransform: 'initial',
  },
}));
